<template>
  <div class="d-block d-lg-flex my-4">
    <!-- buscador y filtros desktop y movil -->
    <div
      class="buscador col row-lg input-group input-group-lg col-lg-12 mx-auto px-0"
    >
      <div class="col row-lg buscador btn-group w-100 px-0 ml-0">
        <div class="col-12 row px-0 ml-0">
          <div class="buscador btn-group col-lg-3 mb-3 mb-lg-0 px-0">
            <div class="w-100 px-0 mr-lg-3">
              <b-form-select
                size="lg"
                class="custom-select form-control-lg multiple region"
                v-model="busqueda.region"
                @change="cambiarRegion(busqueda.region)"
              >
                <option disabled value="null">Región</option>
                <option
                  v-for="r in regiones"
                  :key="r.idRegion"
                  :value="r.valorBusqueda"
                >
                  {{ limpiarNombreRegion(r.nombreRegion) }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-12 col-lg-3 row px-0 mx-0">
            <div class="w-100 px-0 mr-lg-3">
              <b-form-select
                v-model="institutoSeleccionado"
                class="custom-select multiple instt mb-3 mb-lg-0"
                @change="cambiarInstitucion(institutoSeleccionado)"
              >
                <option disabled value="null">Institución</option>
                <option
                  :value="instituto"
                  v-for="instituto in obtenerInstituciones"
                  :key="instituto.index"
                >
                  {{ instituto }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-12 col-lg-3 row px-0 mx-0">
            <div class="px-0 w-100 mr-lg-3">
              <b-form-select
                v-model="sectorSeleccionado"
                class="custom-select multiple area mb-3 mb-lg-0"
                @change="cambiarSector(sectorSeleccionado)"
              >
                <option disabled value="null">Sector Económico</option>
                <option
                  :value="sector"
                  v-for="sector in obtenerSector"
                  :key="sector.index"
                >
                  {{ sector }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-12 col-lg-3 row px-0 ml-0">
            <div class="px-0 w-100">
              <b-form-select
                v-model="cGenericaSeleccionada"
                class="custom-select multiple carrera"
                @change="cambiarCarreraGenerica(cGenericaSeleccionada)"
              >
                <option disabled value="null">Carrera Genérica</option>
                <option
                  :value="carrera"
                  v-for="carrera in obtenerCarreras"
                  :key="carrera.index"
                >
                  {{ carrera }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>

          <div class="buscador btn-group col-lg-3 w-100 mt-3 px-0 pr-lg-3">
            <div class="w-100 px-0">
              <b-form-select
                v-model="busqueda.jornada"
                @change="cambiarJornada"
                class="custom-select multiple gratuidad"
              >
                <option disabled value="null">Modalidad</option>
                <option
                  v-for="opcion in optionsJornada"
                  :key="opcion.index"
                  :value="opcion.valor"
                >
                  {{ opcion.texto }}
                </option>
              </b-form-select>
            </div>
          </div>

          <div class="buscador btn-group col-lg-9 mt-3 mb-lg-0 px-0">
            <Autocompletado
              :nombreCarrera="busqueda.carrera"
              :matches="itemsAutocomplet"
              textoPlaceHolder="Nombre Carrera"
              @selected="buscarNombreCarrera"
              @asignarTextoIncompleto="asignarTextoIncompleto"
              @change="busquedaAutocompletado"
              @busquedaExacta="busquedaExacta"
            />
          </div>
        </div>
      </div>

      <div class="input-lg ml-3 pr-0 flex-shrink-1 d-none d-lg-block">
        <button
          class="btn btn-blue rounded-0 px-3 pl-3 h-100"
          type="button"
          v-b-tooltip.hover
          title="Buscar"
          @click="buscarBoton"
        >
          <FontAwesomeIcon icon="search" class="mt-1" />
        </button>
      </div>
      <div
        class="col-12 mt-3 input-lg align-self-center px-0 d-block d-lg-none"
      >
        <button
          class="btn btn-blue w-100 rounded-0"
          type="button"
          id="inputGroupFileAddon"
          v-b-tooltip.hover
          title="Buscar"
          @click="buscarBoton"
        >
          <FontAwesomeIcon icon="search" class="mt-1" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ApiBuscador from "@/services/ApiBuscador";
import Busqueda from "@/utils/Busqueda.js";
import Autocompletado from "@/components/generales/Autocompletado";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapGetters, mapActions } from "vuex";
import MixinRegiones from "@/mixins/regiones.js";
library.add(faSearch, faPlus);
export default {
  name: "FormBusqueda",
  mixins: [MixinRegiones],
  components: {
    FontAwesomeIcon,
    Autocompletado,
  },
  data() {
    return {
      busqueda: {
        region: null,
        carrera: "",
        sectorProductivo: null,
        nombreCarreraGenerico: null,
        nombreInstitucion: null,
        busquedaExacta: null,
        jornada: null,
      },
      sectores: [],
      areasCarrerasInstitutos: [],
      sectorSeleccionado: null,
      cGenericaSeleccionada: null,
      institutoSeleccionado: null,
      jornadaSeleccionada: null,
      itemsAutocomplet: [],
    };
  },
  async created() {
    this.reiniciarBusquedaAplicada();
    this.areasCarrerasInstitutos = await this.buscarDatosAreaCarreraInstituto();
  },
  watch: {
    getNombreCarreraSeleccionada(val) {
      this.busqueda.carrera = val;
    },
    getRegionSeleccionada(val) {
      this.busqueda.region = val;
      this.buscarDatosAreaCarreraInstituto();
    },
    getAreaConocimientoSeleccionada(val) {
      this.sectorSeleccionado = val;
    },
    getCarreraGenericaSeleccionada(val) {
      this.cGenericaSeleccionada = val;
    },
    getInstitucionSeleccionada(val) {
      this.institutoSeleccionado = val;
    },
    getJornada(val) {
      this.busqueda.jornada = val;
    },
  },
  computed: {
    ...mapGetters([
      "getBusquedasAplicadas",
      "getRegionSeleccionada",
      "getNombreCarreraSeleccionada",
      "getAreaConocimientoSeleccionada",
      "getCarreraGenericaSeleccionada",
      "getInstitucionSeleccionada",
      "getJornada",
    ]),
    obtenerSector() {
      if (this.areasCarrerasInstitutos.length >= 1) {
        let areas = this.areasCarrerasInstitutos.map((a) => a.sectorProductivo);
        areas = [...new Set(areas)];
        areas.sort((a, b) => a.localeCompare(b));
        return areas;
      } else {
        return [];
      }
    },
    obtenerCarreras() {
      if (this.areasCarrerasInstitutos.length >= 1) {
        let cGenerias = this.areasCarrerasInstitutos;
        cGenerias = this.filtrarCarrera(cGenerias);
        cGenerias = cGenerias.map((c) => c.nombreGenerico);
        cGenerias = [...new Set(cGenerias)];
        cGenerias.sort((a, b) => a.localeCompare(b));
        return cGenerias;
      } else {
        return [];
      }
    },
    obtenerInstituciones() {
      if (this.areasCarrerasInstitutos.length >= 1) {
        let institutos = this.areasCarrerasInstitutos;
        institutos = this.filtrarCarrera(institutos);
        institutos = this.filtrarInstitucion(institutos);
        institutos = institutos.map((ins) => ins.nombreInstitucion);
        institutos = [...new Set(institutos)];
        institutos.sort((a, b) => a.localeCompare(b));
        return institutos;
      } else {
        return [];
      }
    },
    optionsJornada() {
      return Busqueda.criteriosJornada();
    },
  },
  methods: {
    ...mapActions([
      "setBusqueda",
      "setRegionSeleccionada",
      "setNombreCarreraSeleccionada",
      "setAreasCarrerasInstituciones",
      "setAreaConocimientoSeleccionada",
      "setCarreraGenericaSeleccionada",
      "setInstitucionSeleccionada",
      "setJornada",
    ]),
    async busquedaAutocompletado(val) {
      let res = await ApiBuscador.getNombresCarrerasAutocompletado(val);
      if (res !== "") {
        this.itemsAutocomplet = res;
      } else {
        this.itemsAutocomplet = [];
      }
    },
    reiniciarBusquedaAplicada() {
      let busquedasAplicadas = this.getBusquedasAplicadas;
      if (busquedasAplicadas.length > 0) {
        busquedasAplicadas.forEach((f) => {
          switch (f.tipo) {
            case "REGION":
              this.busqueda.region = this.getRegionSeleccionada;
              break;
            case "SECTOR":
              this.sectorSeleccionado = this.getAreaConocimientoSeleccionada;
              this.busqueda.sectorProductivo = this.getAreaConocimientoSeleccionada;
              break;
            case "C_GENERICA":
              this.cGenericaSeleccionada = this.getCarreraGenericaSeleccionada;
              this.busqueda.nombreCarreraGenerico = this.getCarreraGenericaSeleccionada;
              break;
            case "INSTITUCION":
              this.institutoSeleccionado = this.getInstitucionSeleccionada;
              this.busqueda.nombreInstitucion = this.getInstitucionSeleccionada;
              break;
            case "JORNADA":
              this.jornadaSeleccionada = this.getJornada;
              this.busqueda.jornada = this.getJornada;
              break;
            case "CARRERA":
              this.busqueda.carrera = this.getNombreCarreraSeleccionada;
              break;
            default:
              break;
          }
        });
      }
    },
    getAreasCarrerasInstitutos() {
      return this.$store.getters.getAreasCarrerasInstituciones;
    },
    async buscarDatosAreaCarreraInstituto() {
      let parametros = {
        region:
          this.busqueda.region && this.busqueda.region !== "TODAS"
            ? this.busqueda.region
            : null,
      };
      let areasCarrerasInstituciones = await ApiBuscador.getAreaCarreraInstitucionPorRegion(
        parametros
      );
      if (areasCarrerasInstituciones) {
        this.areasCarrerasInstitutos = areasCarrerasInstituciones;
      }
      return areasCarrerasInstituciones;
    },
    buscarCarrera() {
      this.buscarDatosAreaCarreraInstituto();
      this.busqueda.sectorProductivo = this.sectorSeleccionado;
      this.busqueda.nombreCarreraGenerico = this.cGenericaSeleccionada;
      this.busqueda.nombreInstitucion = this.institutoSeleccionado;
      this.$emit("buscarCarrera", this.busqueda);
      this.busqueda.busquedaExacta = null;
    },
    buscarNombreCarrera(val) {
      if (val) {
        this.busqueda.carrera = val;
        this.setNombreCarreraSeleccionada(val);
        this.guardarBusquedaTags(val, "CARRERA");
        this.buscarCarrera();
      }
    },
    buscarBoton() {
      if (
        this.busqueda.region !== null ||
        this.busqueda.carrera !== "" ||
        this.busqueda.sectorProductivo !== null ||
        this.busqueda.nombreCarreraGenerico !== null ||
        this.busqueda.nombreInstitucion !== null ||
        this.busqueda.jornada !== null
      ) {
        if (this.busqueda.carrera !== "") {
          this.setNombreCarreraSeleccionada(this.busqueda.carrera);
          this.guardarBusquedaTags(this.busqueda.carrera, "CARRERA");
        }
        this.buscarCarrera();
      }
    },
    busquedaExacta(val) {
      this.busqueda.busquedaExacta = val;
    },
    guardarBusquedaTags(busqueda, tipo) {
      let filtroNuevo = {
        tipo: tipo,
        filtro: busqueda,
        nivel: 0,
        eliminable: true,
      };
      let filtrosPrevios = [...this.getBusquedasAplicadas];
      let filtroRepetido = filtrosPrevios.findIndex(
        (f) => f.tipo === filtroNuevo.tipo
      );
      if (filtroRepetido !== -1) {
        filtrosPrevios.splice(filtroRepetido, 1);
      }
      if (filtroNuevo.filtro !== null) {
        filtrosPrevios.push(filtroNuevo);
      }
      this.setBusqueda(filtrosPrevios);
    },
    cambiarRegion(val) {
      this.sectorSeleccionado = null;
      this.cGenericaSeleccionada = null;
      this.institutoSeleccionado = null;
      this.setRegionSeleccionada(val);
      this.setAreaConocimientoSeleccionada(null);
      this.setCarreraGenericaSeleccionada(null);
      this.setInstitucionSeleccionada(null);
      this.guardarBusquedaTags(val, "REGION");
      this.buscarCarrera();
    },
    cambiarSector(val) {
      this.cGenericaSeleccionada = null;
      this.institutoSeleccionado = null;
      this.setAreaConocimientoSeleccionada(val);
      this.setCarreraGenericaSeleccionada(null);
      this.setInstitucionSeleccionada(null);
      this.guardarBusquedaTags(val, "SECTOR");
      this.buscarCarrera();
    },
    cambiarCarreraGenerica(val) {
      this.institutoSeleccionado = null;
      this.setCarreraGenericaSeleccionada(val);
      this.setInstitucionSeleccionada(null);
      this.guardarBusquedaTags(val, "C_GENERICA");

      this.buscarCarrera();
    },
    cambiarInstitucion(val) {
      this.setInstitucionSeleccionada(val);
      this.guardarBusquedaTags(val, "INSTITUCION");
      this.buscarCarrera();
    },
    cambiarJornada(val) {
      this.setJornada(val);
      this.guardarBusquedaTags(val, "JORNADA");
      this.buscarCarrera();
    },
    filtrarCarrera(arreglo) {
      if (
        this.sectorSeleccionado !== null &&
        this.sectorSeleccionado !== "TODAS"
      ) {
        return arreglo.filter(
          (c) => c.sectorProductivo === this.sectorSeleccionado
        );
      } else {
        return arreglo;
      }
    },
    filtrarInstitucion(arreglo) {
      if (
        this.cGenericaSeleccionada !== null &&
        this.cGenericaSeleccionada !== "TODAS"
      ) {
        return arreglo.filter(
          (i) => i.nombreGenerico === this.cGenericaSeleccionada
        );
      } else {
        return arreglo;
      }
    },
    asignarTextoIncompleto(val) {
      this.busqueda.carrera = val;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/buscadorTP/FormBusqueda.vue